import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './MonthlyAttendance.css';
import { useNavigate } from 'react-router-dom';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDaysInMonth, initializeAttendanceData } from '../../../utils/calculateDaysInMonthUtils';
import { fetchMonths, getDistrict, getProject, getClients, getStates, fetchEmployeePostingByLocation } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
const MonthlyAttendance = () => {
    const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [state, setState] = useState(3);
  const [district, setDistrict] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(currentYear);
  const [project, setProject] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [projectResponse, setProjectResponse] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [onConfirmAction, setOnConfirmAction] = useState(null);

  const [clientResponse, setClientResponse] = useState([]);
  const [clients, setClients] = useState(1);
  const [isFocused, setIsFocused] = useState({
    state: false,
    district: false,
    month: false,
    year: false,
    project: false,
    clients: false,
  });
  const [errors, setErrors] = useState({});
  const [hasFetched, setHasFetched] = useState(false);
  const yearInputRef = useRef(null);
  const isFetchDataEnabled = state && district && month && year && project;


  const effectRan = useRef(false);
  // Function to calculate days in a month
  // const getDaysInMonth = (monthId, year) => {
  //   const monthIndex = monthId - 1;
  //   if (!monthId || !year) return 0;
  //   const monthsWith31Days = [1, 3, 5, 7, 8, 10, 12];
  //   const monthsWith30Days = [4, 6, 9, 11];
  //   if (monthsWith31Days.includes(monthId)) {
  //     return 31;
  //   } else if (monthsWith30Days.includes(monthId)) {
  //     return 30;
  //   } else if (monthId === 2) {
  //     const isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  //     return isLeapYear ? 29 : 28;
  //   }
  //   return 0;
  // };

  // Fetch states
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const data = await getStates();
        setStateOptions(
          data.map(item => ({
            value: item.id,
            label: capitalizeFirstLetter(item.stateName),
          }))
        );
      } catch (error) {
        console.error('Error fetching states:', error);
        setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
      }
    };
    if (!effectRan.current) {
      fetchStates();
    }
    return () => {
      effectRan.current = true;
    }
  }, []);

  // Fetch months
  useEffect(() => {
    const loadMonths = async () => {
      try {
        const months = await fetchMonths(year);
        setMonthOptions(months);
      } catch (error) {
        console.error("Error fetching months:", error);
        setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
      }
    };
    // if (!effectRan.current) {
    loadMonths();
    // }
    // return () => {
    //   effectRan.current = true;
    // }
  }, [year]);

  // Fetch districts when state changes
  useEffect(() => {
    if (state) {
      const fetchDistricts = async () => {
        try {
          // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
          const data = await getDistrict(state);
          setDistrictOptions(
            data.map(item => ({
              value: item.districtId,
              label: item.districtName,
            }))
          );
        } catch (error) {
          console.error('Error fetching districts:', error);
          setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
        }
      };
      // if (!effectRan.current) {
      fetchDistricts();
      // }
      // return () => {
      //   effectRan.current = true;
      // }

    } else {
      setDistrictOptions([]);
      setDistrict(null);
      setAttendanceData([]);
      setHasFetched(false);
    }
  }, [state]);

  // Fetch projects

  useEffect(() => {
    if (state) {
      const fetchClients = async () => {
        try {
          const data = await getClients(state);
          setClientResponse(
            data.map(client => ({
              value: client.id,
              label: client.clientName,
            }))
          );
        } catch (error) {
          console.error('Error fetching clients:', error);
          setErrors(prev => ({ ...prev, clients: 'Failed to load clients' }));
        }
      };
      fetchClients();
    } else {
      setClientResponse([]);
      setClients(null);



    }
  }, [state]);
  useEffect(() => {
    if (clients) {
      const fetchProjects = async () => {
        try {
          const data = await getProject(clients);
          setProjectResponse(data.map(pro => ({
            value: pro.id,
            label: pro.projectCode,
          })));
        } catch (error) {
          console.error('Error fetching projects:', error);
          setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
        }
      };

      fetchProjects();
    } else {
      setProjectResponse([]); // Reset projects if no client is selected
    }
  }, [clients]);
  // useEffect(() => {
  //   const fetchProjects = async () => {
  //     try {
  //       //  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
  //       const data = await getProjects();
  //       setProjectResponse(
  //         data.map(pro => ({
  //           value: pro.id,
  //           label: pro.projectCode,
  //         }))
  //       );
  //     } catch (error) {
  //       console.error('Error fetching projects:', error);
  //       setErrors(prev => ({ ...prev, general: 'Failed to load projects' }));
  //     }
  //   };
  //   if (!effectRan.current) {
  //     fetchProjects();
  //   }
  //   return () => {
  //     effectRan.current = true;
  //   }

  // }, [state, district, year]);

  // Restore state from localStorage on component mount
  useEffect(() => {
    const savedState = localStorage.getItem('attendanceFormState');
    if (savedState) {
      const { state, district, month, year, clients, project, attendanceData } = JSON.parse(savedState);
      setState(state);
      setDistrict(district);
      setMonth(month);
      setYear(year);
      setClients(clients);
      setProject(project);
      setAttendanceData(attendanceData);
      setHasFetched(true);
    }
  }, []);

  // Save state to localStorage when attendanceData or form fields change
  useEffect(() => {
    if (attendanceData.length > 0) {
      const savedState = { state, district, month, year, clients, project, attendanceData };
      localStorage.setItem('attendanceFormState', JSON.stringify(savedState));
    }
  }, [attendanceData, state, district, month, year, clients, project]);

  const handleInputChange = (selectedOption, field) => {
    const value = selectedOption ? selectedOption.value : null;
    switch (field) {
      case 'state':
        setState(value);
        setDistrict(null);
        setMonth(null);
        setProject(null);
        setClients(null);
        setAttendanceData([]);
        setHasFetched(false);
        break;
      case 'clients':
        setClients(value);
        setProject(null);
        // setProjectResponse([]);
        // setEmployees([]);
        // setEmployeeData([]);
        break;
      case 'district':
        setDistrict(value);
        //setProject(null);
        setAttendanceData([]);
        setHasFetched(false);
        break;
      case 'month':
        setMonth(value);
        setAttendanceData([]);
        setHasFetched(false);
        break;
      case 'project':
        setProject(value);
        setAttendanceData([]);
        setHasFetched(false);
        break;
      default:
        break;
    }
    setErrors(prev => ({ ...prev, [field]: null }));
  };

  const handleYearChange = (date) => {
    const newYear = date ? date.getFullYear() : null;
    setYear(newYear);
    setMonth(null);
    setAttendanceData([]);
    setHasFetched(false);
    setErrors(prev => ({ ...prev, year: null }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!state) newErrors.state = 'State is required';
    if (!district) newErrors.district = 'District is required';
    if (!month) newErrors.month = 'Month is required';
    if (!year) newErrors.year = 'Year is required';
    if (!project) newErrors.project = 'Project is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = { stateId: state, districtId: district, month, year, projectId: project };

    try {
      const data = await fetchEmployeePostingByLocation(payload);
      console.log("API response:", data);

      setHasFetched(true);
      setOriginalData(data);
      // 🧠 Fix missing designation here
      const updatedData = data.map(item => ({
        ...item,
        designation:
          item.designation && item.designation !== "N/A"
            ? item.designation
            : item.employee?.designation || item.designation || "N/A",
      }));
      const initializedData = initializeAttendanceData(updatedData, month, year);
      setAttendanceData(initializedData);
      //{console.log("Attendance Data:", attendanceData)}
      console.log("Attendance Data (after designation fix):", initializedData);
      //console.log("Attendance Data:", initializedData);
      if (initializedData.length === 0) {
        alert("No employees found for the selected criteria.");
      } else {
        alert(
          initializedData.some(i => i.status === "RESUBMIT")
            ? "Attendance (Resubmission) data fetched successfully!"
            : "Attendance (New Create) data fetched successfully!"
        );
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setErrors(prev => ({ ...prev, general: "Failed to fetch attendance data" }));
      setHasFetched(true);
      alert("Failed to fetch attendance data. Please try again.");
    }
  };
  const handleAttendanceInputChange = (index, field, rawValue) => {
    const daysInMonth = getDaysInMonth(month, year);
    const parsed = rawValue === '' ? '' : parseInt(rawValue, 10);

    setAttendanceData(prev =>
      prev.map((item, i) => {
        if (i !== index) return item;

        const updated = { ...item };

        // === Present Days ===
        if (field === 'presentDays') {
          updated.presentDays = parsed === '' || isNaN(parsed)
            ? ''
            : Math.min(parsed, daysInMonth);
        }

        // === Casual Leave ===
        if (field === 'casualLeave') {
          updated.casualLeave = parsed === '' || isNaN(parsed) ? '' : parsed;

          const baseUsed = (item.originalUsedLeaves ?? 0) - (item.casualLeaveDays ?? 0);
          updated.usedLeaves = parsed === '' ? baseUsed : baseUsed + parsed;
        }

        // === Recalculate Absent Days ===
        const presentNum = Number(updated.presentDays) || 0;
        const clNum = Number(updated.casualLeave) || 0;
        updated.daysAbsent = Math.max(0, daysInMonth - (presentNum + clNum));

        return updated;
      })
    );

    // === VALIDATION LOGIC ===
    const row = attendanceData[index] || {};
    const alreadyUsedCL = row.casualLeaveDays ?? 0;
    const baseUsed = (row.originalUsedLeaves ?? 0) - alreadyUsedCL;
    const newUsed = parsed === '' ? baseUsed : baseUsed + (isNaN(parsed) ? 0 : parsed);

    // Clear old errors first
    setErrors(prev => ({
      ...prev,
      [`casualLeave_${index}`]: null,
      [`usedLeaves_${index}`]: null,
    }));

    if (field === 'casualLeave') {
      if (rawValue === '' || isNaN(parsed)) {
        // Allow empty → no error
      } else {
        // 1. Cannot enter less than already used CL
        if (parsed < alreadyUsedCL) {
          setErrors(prev => ({
            ...prev,
            [`casualLeave_${index}`]: `Cannot enter less than ${alreadyUsedCL} (already used)`,
          }));
        }
        // 2. usedLeaves cannot exceed 16
        else if (newUsed > 16) {
          setErrors(prev => ({
            ...prev,
            [`usedLeaves_${index}`]: 'Used leaves cannot exceed 16',
          }));
        }
        // 3. usedLeaves cannot be negative
        else if (newUsed < 0) {
          setErrors(prev => ({
            ...prev,
            [`usedLeaves_${index}`]: 'Used leaves cannot be negative',
          }));
        }
        // 4. Present + CL ≤ total days
        else {
          const present = Number(row.presentDays) || 0;
          if (present + parsed > daysInMonth) {
            setErrors(prev => ({
              ...prev,
              [`casualLeave_${index}`]: `Present + CL cannot exceed ${daysInMonth} days`,
            }));
          }
        }
      }
    }

    // === Present Days Validation ===
    if (field === 'presentDays') {
      if (rawValue === '' || isNaN(parsed)) {
        // ok
      } else if (parsed > daysInMonth) {
        setErrors(prev => ({
          ...prev,
          [`presentDays_${index}`]: `Present cannot exceed ${daysInMonth}`,
        }));
      }
    }
  };


  // const validateAttendanceInputs = () => {
  //   const newErrors = {};
  //   const daysInMonth = getDaysInMonth(month, year);

  //   attendanceData.forEach((row, index) => {
  //     const presentDays = Number(row.presentDays) || 0;
  //     const casualLeave = Number(row.casualLeave) || 0;
  //     const daysAbsent = row.daysAbsent || 0;
  //     const maxLeaves = row.leaves || 0;

  //     console.log(`Validating row ${index} (${row.fullName}):`, {
  //       presentDays,
  //       casualLeave,
  //       daysAbsent,
  //       daysInMonth,
  //       maxLeaves,
  //       usedLeaves: row.usedLeaves,
  //       sum: presentDays + casualLeave + daysAbsent,
  //     });

  //     if (presentDays > daysInMonth) {
  //       newErrors[`presentDays_${index}`] = `Present days cannot exceed ${daysInMonth} days`;
  //     }
  //     if (casualLeave > maxLeaves) {
  //       newErrors[`casualLeave_${index}`] = `Casual leave cannot exceed ${maxLeaves} days`;
  //     }
  //     if (row.usedLeaves > maxLeaves) {
  //       newErrors[`casualLeave_${index}`] = `Total used leaves (${row.usedLeaves}) cannot exceed available leaves (${maxLeaves})`;
  //     }
  //     if (presentDays + casualLeave + daysAbsent !== daysInMonth) {
  //       newErrors[`daysAbsent_${index}`] = `Total days (Present + Casual Leave + Absent) must equal ${daysInMonth} (Got ${presentDays + casualLeave + daysAbsent})`;
  //     }
  //     if (presentDays < 0) {
  //       newErrors[`presentDays_${index}`] = 'Present days cannot be negative';
  //     }
  //     if (casualLeave < 0) {
  //       newErrors[`casualLeave_${index}`] = 'Casual leave cannot be negative';
  //     }
  //     if (daysAbsent < 0) {
  //       newErrors[`daysAbsent_${index}`] = 'Days absent cannot be negative';
  //     }
  //   });

  //   console.log('Validation errors:', newErrors);
  //   setErrors(prev => ({ ...prev, ...newErrors }));
  //   return Object.keys(newErrors).length === 0;
  // };


  const handleClear = () => {
    setDistrict(null);
    setState(null);
    setMonth(null);
    setYear(null);
    setClients(null);
    setProject(null);
    setAttendanceData([]);
    setHasFetched(false);
    localStorage.removeItem('attendanceData');
    localStorage.removeItem('attendanceFormState');
  };

  const gotoDashboard = () => {
    navigate('/dashboard');
    localStorage.removeItem('attendanceData');
    localStorage.removeItem('attendanceFormState');
  };

  const handlePreview = () => {
    const hasZeroPresent = attendanceData.some(row => Number(row.presentDays) === 0);
    const saveAndPreview = async () => {


      navigate('/monthlyAttendancePreview', {
        state: {
          year,
          month,
          districtId: district,
          projectId: project,
          attendanceData,
        },
      });

    };

    if (hasZeroPresent) {
      setOnConfirmAction(() => saveAndPreview);
      setShowConfirm(true);
    } else {
      saveAndPreview();
    }
  };

  // const selectStyles = {
  //   menuPortal: base => ({ ...base, zIndex: 9999 }),
  //   menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
  //   control: provided => ({ ...provided, padding: '1px' }),
  //   valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
  // };


  const minDate = new Date(2000, 0, 1);
  const maxDate = new Date(currentYear, 11, 31);

  const isAllPresentDaysFilled =
    attendanceData.length > 0 &&
    attendanceData.every(
      row =>
        row.presentDays !== '' &&
        row.presentDays !== null &&
        row.presentDays !== undefined &&
        Number(row.presentDays) > 0
    );

  return (
    <div className="monthly-attendance-container">
      <div className="monthly-attendance-box">
        <h2 className="monthly-attendance-heading">Monthly Attendance Entry Form</h2>
        {errors.general && <div className="error-message">{errors.general}</div>}
        <form onSubmit={handleSubmit}>
          <div className="monthly-attendance-maincontainer">
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                <Select
                  name="state"
                  options={stateOptions}
                  value={stateOptions.find(opt => opt.value === state) || null}
                  onChange={option => handleInputChange(option, 'state')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>State
                </label>
                {errors.state && <div className="error-message">{errors.state}</div>}
              </div>
            </div>
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                <Select
                  name="district"
                  options={districtOptions}
                  value={districtOptions.find(opt => opt.value === district) || null}
                  onChange={option => handleInputChange(option, 'district')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Working District
                </label>
                {errors.district && <div className="error-message">{errors.district}</div>}
              </div>
            </div>
          </div>
          <div className="monthly-attendance-maincontainer">
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                <DatePicker
                  selected={year ? new Date(year, 0, 1) : null}
                  onChange={handleYearChange}
                  onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                  dateFormat="yyyy"
                  showYearPicker
                  placeholderText=""
                  className="monthly-attendance-date-picker"
                  minDate={minDate}
                  maxDate={maxDate}
                  ref={yearInputRef}
                />
                <label>
                  <span className="required">*</span>Year
                </label>
                {errors.year && <div className="error-message">{errors.year}</div>}
              </div>
            </div>
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                <Select
                  name="month"
                  options={monthOptions}
                  value={monthOptions.find(opt => opt.value === month) || null}
                  onChange={option => handleInputChange(option, 'month')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Month
                </label>
                {errors.month && <div className="error-message">{errors.month}</div>}
              </div>
            </div>
          </div>
          <div className="monthly-attendance-maincontainer">
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}>
                <Select
                  name="clients"
                  options={clientResponse}
                  value={clientResponse.find(opt => opt.value === clients) || null}
                  onChange={option => handleInputChange(option, 'clients')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label> <span className="required">*</span>Client</label>
                {errors.clients && <div className="error-message">{errors.clients}</div>}
              </div>

            </div>
            <div className="monthly-attendance-container-part">
              <div className={`monthly-attendance-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                <Select
                  name="project"
                  options={projectResponse}
                  value={projectResponse.find(opt => opt.value === project) || null}
                  onChange={option => handleInputChange(option, 'project')}
                  onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                  onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                  placeholder=" "
                  isClearable
                  menuPortalTarget={document.body}
                  styles={selectStyles}
                />
                <label>
                  <span className="required">*</span>Project
                </label>
                {errors.project && <div className="error-message">{errors.project}</div>}
              </div>
            </div>

          </div>
          <div className="monthly-attendance-btn-div">
            <button
              type="submit"
              className="monthly-attendance-btn"
              disabled={!isFetchDataEnabled}
            >
              Fetch Data
            </button>
          </div>
        </form>
      </div>
      {hasFetched && (
        <div className="attendance-table-container">
          <table className="attendance-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Employee Id</th>
                <th>Employee Name</th>
                <th>Designation</th>
                <th>DHQ/ Godown Name</th>
                <th>No of Days in Month</th>
                <th>No of Days Present</th>
                <th>Casual Leave (CL)</th>
                <th>No of Days Absent</th>
                <th>Total No of Days Present</th>
                <th>CL Used Status</th>
              </tr>
            </thead>
            <tbody>
              {attendanceData.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ textAlign: 'center', padding: '10px' }}>
                    No data available
                  </td>
                </tr>
              ) : (
                attendanceData.map((row, index) => {
                  const daysInMonth = getDaysInMonth(month, year);
                  const daysAbsent = row.daysAbsent || 0;
                  const payableDays = daysAbsent === 0 ? daysInMonth : (row.presentDays || 0) + (row.casualLeave || 0);

                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{row.employeeId || 'N/A'}</td>
                        <td>{row.fullName || 'N/A'}</td>
                        <td>{row.designation || 'N/A'}</td>
                        <td>{row.godownNames || 'N/A'}</td>
                        <td>{daysInMonth}</td>
                        <td>
                          <input
                            type="text"
                            min="0"
                            max={daysInMonth}
                            value={row.presentDays === '' ? '' : Number(row.presentDays)}
                            onFocus={e => {
                              if (e.target.value === '0') {
                                e.target.value = '';
                              }
                            }}
                            onChange={e => handleAttendanceInputChange(index, 'presentDays', e.target.value)}
                            className="attendance-input"
                            style={{ width: '60px' }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            min="0"
                            max={row.leaves || 0}
                            value={row.casualLeave === '' ? '' : Number(row.casualLeave)}
                            onFocus={e => {
                              if (e.target.value === '0') {
                                e.target.value = '';
                              }
                            }}
                            onChange={e => handleAttendanceInputChange(index, 'casualLeave', e.target.value)}
                            className="attendance-input"
                            style={row.leaves === undefined ? { width: '60px', backgroundColor: '#f0f0f0' } : { width: '60px' }}
                          />
                        </td>
                        <td>{row.daysAbsent || 0}</td>
                        <td>{payableDays >= 0 ? payableDays : 0}</td>
                        <td>{row.usedLeaves}/{row.leaves}</td>
                      </tr>
                      {/* {errors[`presentDays_${index}`] || errors[`casualLeave_${index}`] ? (
                        <tr>
                          <td colSpan="11" style={{ color: 'red', textAlign: 'center' }}>
                            {errors[`presentDays_${index}`] || errors[`casualLeave_${index}`]}
                          </td>
                        </tr>
                      ) : null} */}
                      {/* {errors[`usedLeaves_${index}`] && (
                        <tr>
                          <td colSpan="11" style={{ color: 'red', textAlign: 'center' }}>
                            {errors[`usedLeaves_${index}`]}
                          </td>
                        </tr>
                      )} */}
                      {errors[`presentDays_${index}`] || errors[`casualLeave_${index}`] || errors[`usedLeaves_${index}`] ? (
                        <tr>
                          <td colSpan="11" style={{ color: 'red', textAlign: 'center',}}>
                            {errors[`presentDays_${index}`]
                             ||
                              errors[`casualLeave_${index}`] 
                              ||
                              errors[`usedLeaves_${index}`]}
                          </td>
                        </tr>
                      ) : null}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
          {attendanceData.length > 0 && (
            <div className="monthly-submit-btn-div">
              <button onClick={handleClear} className="monthly-clear-btn">Clear</button>
              <button onClick={gotoDashboard} className="monthly-close-btn">Close</button>
              <button
                type="button"
                className="monthly-attendance-btn"
                onClick={handlePreview}
              >
                Preview Attendance
              </button>
            </div>
          )}
          {showConfirm && (
            <div className="custom-modal-overlay-att">
              <div className="custom-modal-att">
                <h3>Attendance Alert</h3>
                <p>Some employees have 0 Present Days. Do you still want to submit?</p>
                <div className="modal-buttons-att">
                  <button
                    onClick={() => {
                      if (onConfirmAction) onConfirmAction();
                      setShowConfirm(false);
                    }}
                  >
                    Yes
                  </button>
                  <button onClick={() => setShowConfirm(false)}>No</button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MonthlyAttendance;